// extracted by mini-css-extract-plugin
module.exports = {"mobile-layout":"_772e1b1e50--mobile-layout--f0GHo","desktop-layout":"_772e1b1e50--desktop-layout--oDASK","desktop-content":"_772e1b1e50--desktop-content--J1lxV"};